import axios from "axios/index";
import store from '../stores/store';
import _ from "lodash";
import moment from "moment";
import {
    getPayloadForPiParityEventLog,
    isBackendOnlyStatusEventType,
    isPaymentSelectionChangedEventType,
    mapPaymentMiniAppStatusEventsResponse,
    PAYMENT_MINI_APP_EVENTS,
    reconcileEventTimeline,
} from '../utils/payment-mini-app-utils';

class SecurePaymentService {
    constructor() {
        this.requestHeaders = {
            "Authorization": "",
            "x-api-key": "",
            "Accept": "application/json"
        };
    }

    getRequestHeaders() {
        const state = store.getState();
        this.requestHeaders = {
            "Authorization": state.AuthReducer.userAccessToken,
            "x-api-key": state.AppReducer.applicationConfig.support_anyware_api_key
        };

        return this.requestHeaders;
    }

    getFloodGateRequestHeaders() {
        const state = store.getState();
        return {
            "Authorization": state.AuthReducer.userAccessToken,
            "x-api-key": state.AppReducer.applicationConfig.client_id,
            'x-gw-ims-org-id':'9E1005A551ED61CA0A490D45@AdobeOrg',
            'x-sandbox-name':state.AppReducer.applicationConfig.floodgate_api_sandbox_name
        };
    }
    getAPIbaseUrl() {
        const state = store.getState();
        return state.AppReducer.applicationConfig.support_anyware_api_url + "/products_support/customers/memos?api_key=" + state.AppReducer.applicationConfig.support_anyware_api_key;
    }

    getCommerceAPIbaseUrl() {
        const state = store.getState();
        return state.AppReducer.applicationConfig.commerce_api_url;
    }

    getFloodGateAPIbaseUrl() {
        const state = store.getState();
        return state.AppReducer.applicationConfig.floodgate_api_url;
    }

    updateToken(tokenDetails) {
        const state = store.getState();
        let tokenUrl = this.getAPIbaseUrl() + '&userId=' + state.AuthReducer.userInfo.userId;
        if(state.UserInfoReducer.termsConditionAccepted){
            tokenUrl = tokenUrl+'&termsAccepted=true'
        }
        return axios({
            url: tokenUrl,
            method: 'post',
            headers: this.getRequestHeaders(),
            data: tokenDetails
        });
    }
    
    loadStateList(countryCode) {
        const state = store.getState();
        return axios(
            {
                url: this.getCommerceAPIbaseUrl()+'/countries/'+countryCode,
                method: 'get',
                headers: {
                    'x-api-key': state.AppReducer.applicationConfig.client_id
                }
            }
        )
    }

    async loadTermsCondition(product,index){
        const state = store.getState();
        const urlData = state.AppReducer.applicationConfig.ims_terms_condition_url+"?client_id="+state.AppReducer.applicationConfig.client_id+"&service_name="+product.tncTemplateName+"&locale="+state.LocaleReducer.value;
        const response = await axios.get(urlData);
        return {
            templateName: product.tncTemplateName,
            tc: response.data,
            selected:false,
            productName: product.productName,
            id:index
        };
    }


    async getEventTermCondition() {
        const fromDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
        const toDate = moment().format('YYYY-MM-DD');
        let eventDataLocal = [];
        const state = store.getState();
        const urlData = state.AppReducer.applicationConfig.support_anyware_api_url+"/sales_services/customers/event/logger?rowCount=15&event_type=ORDER_PLACEMENT_TNC&customer_guid="+state.AuthReducer.userInfo.userId+"&fromDate="+fromDate+"&toDate="+toDate;
        try {
            const response = await axios.get(urlData,{
                headers: this.getRequestHeaders(),
            });
            if(response.data && response.data.responseData && response.data.responseData.length){
                //--start--- Filtering USED events from the event list 
                let eventList = response.data.responseData.filter(item => _.has(item,'STATUS') && item.STATUS === 'USED' ? false: true );
                eventList = _.orderBy(eventList, ['INSERT_TIMESTAMP'], ['desc']);
                // ---END---

                eventList.forEach(obj => {
                    obj.METADATA = obj.METADATA ? JSON.parse(obj.METADATA) : {};
                    obj.METADATA.PRODUCT_ITEMS = obj.METADATA.PRODUCT_ITEMS ? JSON.parse(obj.METADATA.PRODUCT_ITEMS) : [];
                });
                if(eventList[0].METADATA["PRODUCT_ITEMS"] && eventList[0].METADATA["PRODUCT_ITEMS"].length){
                    const list = eventList[0].METADATA["PRODUCT_ITEMS"].map((product,index) => this.loadTermsCondition(product,index))
                    eventDataLocal = await Promise.all(list);
                }
            }
        } catch(error) {
            console.log(error)
        }
        return eventDataLocal;
    }

    async getEventLogTermCondition(){
        let eventDataLocal = [];
        const state = store.getState();
        const urlData = state.AppReducer.applicationConfig.hendrix_api_url+"/communication/message/fetch/"+state.AuthReducer.userInfo.email+'?messagetype=ORDER_PLACEMENT_TNC';
        try {
            const response = await axios.get(urlData,{
                headers: this.getRequestHeaders(),
            });
           
            if(response && response.data && response.data.message){
                response.data.message = response.data.message ? JSON.parse(response.data.message) : {};
                response.data.message.PRODUCT_ITEMS = response.data.message.PRODUCT_ITEMS ? response.data.message.PRODUCT_ITEMS : [];
                const list = response.data.message.PRODUCT_ITEMS.map((product,index) => this.loadTermsCondition(product,index))
                eventDataLocal = await Promise.all(list);
            }
        } catch(error) {
            console.log(error);
            throw new Error(error);
        }
        return eventDataLocal;
    }

    async getEventMiniWallet() {
        let eventDataLocal = {};
        const state = store.getState();
        const email = state.AuthReducer.userInfo.email
        const urlData = state.AppReducer.applicationConfig.hendrix_api_url+"/communication/message/fetch/"+email+'?messagetype=CUSTOMER_DETAILS_WALLET_APP';
        try {
            const response = await axios.get(urlData,{
                headers: this.getRequestHeaders(),
            });
            if(response.data){
                response.data.message = response.data.message ? JSON.parse(response.data.message) : {};
                eventDataLocal = response.data;  
            }
        } catch(error) {
            console.log(error)
        }
        return eventDataLocal
    }

    async getPiParityDetails() {
        let eventDataLocal = {};
        const state = store.getState();
        const email = state.AuthReducer.userInfo.email
        const urlData = state.AppReducer.applicationConfig.hendrix_api_url+"/communication/message/fetch/"+email+'?messagetype=CUSTOMER_DETAILS_PI_PARITY';
        try {
            const response = await axios.get(urlData,{
                headers: this.getRequestHeaders(),
            });
            if(response.data){
                response.data.message = response.data.message ? JSON.parse(response.data.message) : {};
                eventDataLocal = response.data;
            }
        } catch(error) {
            console.log(error)
        }
        return eventDataLocal
    }

    /**
     * Fetches the existing Hendrix row for `SPP_PAYMENT_EVENTS` (same pattern as {@link getPiParityDetails}).
     * Used to populate the message/update PUT envelope (ids, receiver, messagetype).
     * Top-level fields on the row (e.g. `messangerid`, `secondarybusinessid`) are kept as returned; only
     * `message` is parsed from JSON string to an object/array.
     * @param {string} [orderId] When set (e.g. pay-link), included as `messangerid` query param.
     */
    async getSppPaymentEventsDetails(orderId) {
        let eventDataLocal = {};
        const state = store.getState();
        const email = state.AuthReducer.userInfo.email;
        const base = state.AppReducer.applicationConfig.hendrix_api_url;
        const id =
            orderId !== undefined && orderId !== null
                ? String(orderId).trim()
                : '';
        const query = new URLSearchParams({ messagetype: 'SPP_PAYMENT_EVENTS' });
        if (id.length > 0) {
            query.set('messangerid', id);
        }
        const urlData = `${base}/communication/message/fetch/${email}?${query.toString()}`;
        try {
            const response = await axios.get(urlData, {
                headers: this.getRequestHeaders(),
            });
            if (response.data) {
                response.data.message = response.data.message
                    ? JSON.parse(response.data.message)
                    : {};
                eventDataLocal = response.data;
            }
        } catch (error) {
            console.log(error);
        }
        return eventDataLocal;
    }

    /**
     * Fetches persisted `SPP_PAYMENT_EVENTS` rows for pay-link telemetry (by email + order).
     * @param {{ customerEmailId?: string; orderNumber?: string }} [options]
     * @returns {Promise<ReadonlyArray<{ eventType: string; status: string }>>}
     */
    async getPaymentMiniAppStatusEvents(options) {
        const opts = options || {};
        const customerEmailId =
            opts.customerEmailId != null
                ? String(opts.customerEmailId).trim()
                : '';
        const orderNumber =
            opts.orderNumber != null ? String(opts.orderNumber).trim() : '';
        if (!customerEmailId || !orderNumber) {
            return mapPaymentMiniAppStatusEventsResponse({
                status: 204,
                data: null,
            });
        }
        const state = store.getState();
        const base = state.AppReducer.applicationConfig.hendrix_api_url;
        if (!base) {
            return mapPaymentMiniAppStatusEventsResponse({
                status: 204,
                data: null,
            });
        }
        const query = new URLSearchParams({
            messagetype: 'SPP_PAYMENT_EVENTS',
            messangerid: orderNumber,
        });
        const urlData = `${base}/communication/message/fetch/${encodeURIComponent(customerEmailId)}?${query.toString()}`;
        try {
            const response = await axios.get(urlData, {
                headers: this.getRequestHeaders(),
            });
            return mapPaymentMiniAppStatusEventsResponse(response);
        } catch (error) {
            console.log(error);
            return mapPaymentMiniAppStatusEventsResponse({
                status: 204,
                data: null,
            });
        }
    }

    loadFeatureFlag() {
        const state = store.getState();
        return axios({
            url: this.getFloodGateAPIbaseUrl()+"/feature?clientId=" + state.AppReducer.applicationConfig.client_id + "&meta=true",
            method: 'get',
            headers: {
                ...this.getFloodGateRequestHeaders(),
                'Content-Type': "application/json"
            }
        });
    }

    /**
     * PUT `hendrix_api_url/communication/message/update`. Envelope fields for the PUT come from
     * the `SPP_PAYMENT_EVENTS` Hendrix message (`getSppPaymentEventsDetails` / Redux
     * `sppPaymentEventsMessage`), not from `CUSTOMER_DETAILS_PI_PARITY`. Optional `metadata`
     * overrides; auth fallbacks apply when receiver fields are missing from the envelope.
     */
    async logPiParityEvents(eventType, metadata = {}) {
        if (isBackendOnlyStatusEventType(eventType)) {
            return null;
        }
        const state = store.getState();
        const meta = metadata || {};
        const userInfo = state.AuthReducer.userInfo || {};
        const emailForRequest = String(
            userInfo.email || meta.email || '',
        ).trim();
        const base = state.AppReducer.applicationConfig.hendrix_api_url;
        const prior = state.SecurePaymentReducer.piParityPaymentEventsLog || [];
        const { record, records } = getPayloadForPiParityEventLog(eventType, prior);
        if (!record) {
            return null;
        }
        // Redux first: earlier calls may have skipped the PUT when email or hendrix_api_url was not ready.
        store.dispatch({ type: 'SET_PI_PARITY_PAYMENT_EVENTS_LOG', records });
        if (!base) {
            return record;
        }
        let sppEnvelope = state.UserInfoReducer.sppPaymentEventsMessage;
        if (sppEnvelope == null) {
            const orderIdForFetch =
                meta.orderId !== undefined && meta.orderId !== null
                    ? String(meta.orderId).trim()
                    : '';
            const fetched = await this.getSppPaymentEventsDetails(
                orderIdForFetch || undefined,
            );
            sppEnvelope = fetched && typeof fetched === 'object' ? fetched : {};
            store.dispatch({
                type: 'SET_SPP_PAYMENT_EVENTS_MESSAGE',
                value: sppEnvelope,
            });
        }
        const guid = _.has(userInfo, 'customerGuidWithAuthSrc') ? userInfo.customerGuidWithAuthSrc : '';
        const guidFallback = userInfo.userId != null ? String(userInfo.userId) : '';
        const envelope = sppEnvelope || {};
        const messagereceiverguid =
            meta.messagereceiverguid ||
            envelope.messagereceiverguid ||
            guid ||
            guidFallback;
        const messagereceiverid = String(
            meta.messagereceiverid || envelope.messagereceiverid || emailForRequest || '',
        ).trim();
        if (!messagereceiverid) {
            return record;
        }
        const messageid =
            meta.messageId || meta.messageid || envelope.messageId || envelope.messageid;
        const messangerid =
            meta.messangerid || meta.messengerid || envelope.messangerid || envelope.messengerid;
        const messagetypePut =
            (envelope.messagetype && String(envelope.messagetype).trim()) || 'SPP_PAYMENT_EVENTS';
        const messagereceiverchannelPut =
            (envelope.messagereceiverchannel && String(envelope.messagereceiverchannel).trim()) ||
            'hendrix';
        const orderNumberForEvents = String(
            meta.messangerid ||
                meta.messengerid ||
                meta.orderId ||
                envelope.messangerid ||
                envelope.messengerid ||
                '',
        ).trim();
        let messageRecords = records;
        const shouldGetReconcile =
            (eventType === PAYMENT_MINI_APP_EVENTS.PAYMENT_SUBMITTED ||
                isPaymentSelectionChangedEventType(eventType)) &&
            orderNumberForEvents.length > 0 &&
            emailForRequest.length > 0;
        if (shouldGetReconcile) {
            const backendEvents = await this.getPaymentMiniAppStatusEvents({
                customerEmailId: emailForRequest,
                orderNumber: orderNumberForEvents,
            });
            messageRecords = reconcileEventTimeline(records, backendEvents);
            if (JSON.stringify(records) !== JSON.stringify(messageRecords)) {
                store.dispatch({
                    type: 'SET_PI_PARITY_PAYMENT_EVENTS_LOG',
                    records: messageRecords,
                });
            }
        } else if (eventType === PAYMENT_MINI_APP_EVENTS.USER_LOGIN) {
            const backendFromEnvelope = Array.isArray(envelope.message)
                ? envelope.message
                : [];
            messageRecords = reconcileEventTimeline(records, backendFromEnvelope);
            if (JSON.stringify(records) !== JSON.stringify(messageRecords)) {
                store.dispatch({
                    type: 'SET_PI_PARITY_PAYMENT_EVENTS_LOG',
                    records: messageRecords,
                });
            }
        }
        const putBody = {
            messagereceiverguid,
            messagereceiverid,
            messagereceiverchannel: messagereceiverchannelPut,
            message: JSON.stringify(messageRecords),
            messagetype: messagetypePut,
            messageid,
        };
        if (messangerid) {
            putBody.messangerid = messangerid;
        }
        try {
            await axios.put(
                `${base}/communication/message/update`,
                putBody,
                {
                    headers: {
                        ...this.getRequestHeaders(),
                        'Content-Type': 'application/json',
                    },
                    // Hendrix 401 here is not treated as global IMS failure (avoids full sign-out).
                    skipImsSignOutOn401: true,
                },
            );
            store.dispatch({
                type: 'SET_SPP_PAYMENT_EVENTS_MESSAGE',
                value: {
                    ...envelope,
                    message: messageRecords,
                },
            });
        } catch (e) {
            console.log(e);
            // Do not revert `piParityPaymentEventsLog` to `prior`: prior is from the start of this
            // call and is often [], so rollback would wipe the chain and break the next payload.
        }
        return record;
    }
}
const securePaymentService = new SecurePaymentService();

export async function getPaymentMiniAppStatusEvents(options) {
    return securePaymentService.getPaymentMiniAppStatusEvents(options);
}

export default securePaymentService;
